import moment from 'moment';
import { z } from 'zod';
import { globalFormat } from '../../../utils/formatting';
import { inputDateFormatDictionary } from './utils';

const dateStringSchema = z
  .string()
  .min(1, 'Date cannot be empty')
  .superRefine((value, ctx) => {
    const { dateFormat } = globalFormat.getGlobalFormat();
    // Validating entered value to be a valid date
    if (!moment(value, inputDateFormatDictionary[dateFormat], true).isValid()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          'Invalid date format, please use format: ' +
          inputDateFormatDictionary[dateFormat],
        fatal: true,
      });

      return z.NEVER;
    }
  });

export const dateStringValidation = z.object({
  value: dateStringSchema,
});
